import { b as baseTokens } from './output/ts/base-BoX_-CJl-BoX_-CJl.js';
import { l as lightThemeTokens } from './output/ts/light-CfXB72FE-CfXB72FE.js';
import { d as darkThemeTokens } from './output/ts/dark-BTFHiONW-BTFHiONW.js';
import { d as deepMerge } from '../../../storm-ui-utils/dist/esm/deepMerge-DmW5IEKC-DLFdHXY0.js';

/**
 * Utility type for deeply merging two types together. Significantly commented because
 * this is some dark magic.
 */

const enhancedBaseTokens = {
  ...baseTokens,
  color: {
    ...baseTokens.color,
    // TODO: remove in v5
    clementine: {
      ...baseTokens.color.orange
    }
  }
};
/**
 * The Storm default light theme (includes both base tokens and light theme tokens).
 */
const stormLightTheme = deepMerge(lightThemeTokens, enhancedBaseTokens);

/**
 * The Storm default dark theme (includes both base tokens and dark theme tokens).
 */
deepMerge(darkThemeTokens, enhancedBaseTokens);

export { stormLightTheme as s };
//# sourceMappingURL=index-8oML1Vmr.js.map
